import { render, staticRenderFns } from "./LoadingTaza.vue?vue&type=template&id=53bd013a&scoped=true&"
import script from "./LoadingTaza.vue?vue&type=script&lang=js&"
export * from "./LoadingTaza.vue?vue&type=script&lang=js&"
import style0 from "./LoadingTaza.vue?vue&type=style&index=0&id=53bd013a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd013a",
  null
  
)

export default component.exports